import React, { useState, useEffect } from 'react';
import { Container, Col, Row } from "react-bootstrap";
import { Link } from "gatsby"
import './assets/styles/_index.scss';
import { bookViewingURL, makeEnquiryURL, registerInterestURL } from '../../site/urls';
import { People_Email } from "../../queries/common_use_query"
import { getWhatsAppURL, getWhatsAppTEXT } from '../../site/utils';

// Negotiator details
const NegoDetailsData = (email_id) => {

    const { loading, error, data } = People_Email(email_id);

    // console.log("nego_info ==>", data);
    return data;
}
// Negotiator details

const BookaViewing = (props) => {
    var nego_info = props?.propertyData?.crm_negotiator_id && props?.propertyData?.crm_negotiator_id?.email && NegoDetailsData(props?.propertyData?.crm_negotiator_id?.email);
    var negInfo = {
        name: props?.propertyData?.crm_negotiator_id?.name,
        email: props?.propertyData?.crm_negotiator_id?.email,
        phone: props?.propertyData?.crm_negotiator_id?.phone
    };
    if (nego_info && nego_info?.teams && nego_info?.teams?.length > 0) {
        let team = nego_info?.teams[0]
        negInfo.name = team.name;
        negInfo.email = team.email;
        negInfo.phone = team.mobile_no ? team.mobile_no : negInfo.phone;
    }
    return (
        <>
        {props.isHolidayhomes ? 
            <section className="holidayhomes-wrapper d-lg-none d-block w-100">
                <Link to={`${makeEnquiryURL}?pid=${props?.propertyData?._id}`} className="button button-primary"><i className="icon icon-nego-mail"></i> <span>Make Enquiry</span></Link>
            </section>
            :
            <section className="bookaviewing-wrapper d-lg-none d-flex align-items-end justify-content-between">
                <div>
                    <Link to={`${props.isOffplan ? registerInterestURL : bookViewingURL}?pid=${props?.propertyData?._id}`} className="button button-primary"><i className="icon icon-nego-mail"></i> <span>Email Agent</span></Link>
                </div>
                { negInfo?.phone && 
                <>
                    <div>
                        <a href={"tel:"+negInfo?.phone}className="button button-secondary"><i className="icon icon-nego-phone"></i> <span>{negInfo?.phone}</span></a>
                    </div>
                    <div>
                        <a href={`${getWhatsAppURL(negInfo?.phone)}?&text=${getWhatsAppTEXT(props)}`}target="_blank" className="button button-secondary mb-0"><i className="icon icon-nego-whatsapp"></i> <span>Click to Whatsapp</span></a>
                    </div>
                </>
                }
            </section>
            }
        </>
    )
}

export default BookaViewing